(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["funtek-viewport-blur"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeFooterReveal = () => {
      const effectRoot = document.querySelector('.funtek-viewport-blur');
      const footerAnchor = document.querySelector('.shopify-section-group-footer-group');
      if (!effectRoot || !footerAnchor || effectRoot.dataset.footerRevealReady === 'true') return;

      const footer = footerAnchor.querySelector('.ft-footer') || footerAnchor;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileViewport = window.matchMedia('(max-width: 639px)');
      let frame = 0;
      let footerTop = 0;
      let revealDistance = 1;
      let maxShift = 0;

      effectRoot.dataset.footerRevealReady = 'true';
      footer.classList.add('funtek-footer-reveal');

      const render = () => {
        frame = 0;
        if (reducedMotion.matches || mobileViewport.matches) {
          footer.style.setProperty('--funtek-footer-reveal-y', '0px');
          footer.classList.remove('is-active');
          return;
        }

        const start = footerTop - window.innerHeight;
        const progress = Math.min(1, Math.max(0, (window.scrollY - start) / revealDistance));
        const shift = maxShift * (progress - 1);
        footer.style.setProperty('--funtek-footer-reveal-y', `${shift.toFixed(2)}px`);
        footer.classList.toggle('is-active', progress > 0 && progress < 1);
      };

      const queueRender = () => {
        if (frame) return;
        frame = window.requestAnimationFrame(render);
      };

      const measure = () => {
        if (reducedMotion.matches || mobileViewport.matches) {
          queueRender();
          return;
        }
        footerTop = footerAnchor.offsetTop;
        revealDistance = Math.max(1, Math.min(footerAnchor.offsetHeight, window.innerHeight) * .86);
        maxShift = Math.min(96, window.innerHeight * .12);
        queueRender();
      };

      window.addEventListener('scroll', queueRender, { passive: true });
      window.addEventListener('resize', measure, { passive: true });
      reducedMotion.addEventListener('change', measure);
      mobileViewport.addEventListener('change', measure);

      if ('ResizeObserver' in window) {
        new ResizeObserver(measure).observe(footerAnchor);
      }

      measure();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeFooterReveal, { once: true });
    } else {
      initializeFooterReveal();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
